import React from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import { AUTH_CONFIG } from "../common/configs/auth.config";
import { appConstants } from "../common/constants/constants";
import { ENVIRONMENT, SSO_BASE_PATH } from "../common/constants/constants";
import { getEnvironment } from "../common/utils";
import Dashboard from "../containers/dashboardMain/dashboard";
import ExternalLoginScreen from "./login/ExternalLoginScreen";
import LoginScreen from "./login/loginScreen";
import SSOLoginScreen from "./login/SSOLoginScreen";
import Signinhelp from "./login/Signinhelp";
import ProtectedRoute from "./ProtectedRoute";
import Eula from "./legal/eula";
import DataAgreement from "./legal/dataAgreement";
import CryptoJS from "crypto-js";
import { generatePKCE } from "../common/utils/pkceUtils";

const ENV = getEnvironment();

async function getPKCEAuthUrl(loginType = appConstants.External) {
  const { codeVerifier, codeChallenge } = await generatePKCE();
  sessionStorage.setItem("pkce_code_verifier", codeVerifier);
  let client_id =
    loginType === appConstants.Internal
      ? AUTH_CONFIG.CLIENT_ID
      : AUTH_CONFIG.EXT_CLIENT_ID;
  let redirect_uri =
    loginType === appConstants.Internal
      ? AUTH_CONFIG.REDIRECT_URI_LOCAL
      : AUTH_CONFIG.EXT_REDIRECT_URI_LOCAL;
  if (ENV === ENVIRONMENT.PROD) {
    redirect_uri =
      loginType === appConstants.Internal
        ? AUTH_CONFIG.REDIRECT_URI_PROD
        : AUTH_CONFIG.EXT_REDIRECT_URI_PROD;
  } else if (ENV === ENVIRONMENT.QA) {
    redirect_uri =
      loginType === appConstants.Internal
        ? AUTH_CONFIG.REDIRECT_URI_QA
        : AUTH_CONFIG.EXT_REDIRECT_URI_QA;
  } else if (ENV === ENVIRONMENT.DEV) {
    redirect_uri =
      loginType === appConstants.Internal
        ? AUTH_CONFIG.REDIRECT_URI_DEV
        : AUTH_CONFIG.EXT_REDIRECT_URI_DEV;
  }
  let url =
    SSO_BASE_PATH() +
    "/as/authorization.oauth2?response_type=code" +
    "&client_id=" +
    client_id +
    "&redirect_uri=" +
    redirect_uri +
    "&scope=openid%20profile%20email" +
    "&code_challenge=" +
    codeChallenge +
    "&code_challenge_method=S256";
  return url;
}

function LoginRedirect({ loginType }) {
  React.useEffect(() => {
    (async () => {
      let pkceUrl = await getPKCEAuthUrl(loginType);
      if (localStorage.getItem("businessLinkId") !== null) {
        let businessLinkId = localStorage.getItem("businessLinkId");
        pkceUrl = pkceUrl + "&businessLinkId=" + businessLinkId;
        localStorage.removeItem("businessLinkId");
      }
      window.location.href = pkceUrl;
    })();
  }, [loginType]);
  return null;
}

const AppRoute = (props) => {
  return (
    <Router>
      <Switch>
        <Route path="/login" component={SSOLoginScreen} />
        <ProtectedRoute path="/dashboard" component={Dashboard} />
        <Route path="/auth" component={LoginScreen} />
        <Route path="/ext/auth" component={ExternalLoginScreen} />
        <Route path="/eula" component={Eula} />
        <Route path="/dataagreement" component={DataAgreement} />
        <Route path="/sign-in-help" component={Signinhelp} />
        <Route path="/">
          <Redirect to="/login" />
        </Route>
        <Route path="">
          <Redirect to="/login" />
        </Route>
        <Route render={() => <h1>404 Page not found</h1>} />
      </Switch>
    </Router>
  );
};

export default AppRoute;
